
import { InjectionSiteDto, CreateInjectionSiteDto, UpdateInjectionSiteDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { injectionSiteService, InjectionSitesFilters } from '@services/InjectionSiteService'

const { reducer, actions, thunks } = baseCrudReducer<
  InjectionSiteDto,
  CreateInjectionSiteDto,
  UpdateInjectionSiteDto,
  InjectionSitesFilters
>('injectionSite', injectionSiteService)

export default reducer

export const { setFilters: setInjectionSiteFilters } = actions

export const {
  getAll: getInjectionSites,
  create: createInjectionSite,
  update: updateInjectionSite,
  remove: removeInjectionSite,
} = thunks
